"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const spinners_1 = require("./spinners");
// interface IProps {}
exports.Spinner = () => {
    const [spinnerCycleLocation, setSpinnerCycleLocation] = react_1.default.useState(0);
    const [spinner, setSpinnerType] = react_1.default.useState(null);
    react_1.useEffect(() => {
        const spinnerKeys = Object.keys(spinners_1.spinners);
        const newSpinner = spinners_1.spinners[spinnerKeys[Math.floor(Math.random() * spinnerKeys.length)]];
        const frameCount = newSpinner.frames.length;
        const interval = setInterval(() => {
            setSpinnerCycleLocation(c => (c > frameCount - 2 ? 0 : c + 1));
        }, newSpinner.interval);
        setSpinnerType(newSpinner);
        return () => {
            clearInterval(interval);
        };
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null, spinner && spinner.frames[spinnerCycleLocation]);
};
//# sourceMappingURL=index.js.map